var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnmute(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_908_50)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "black",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.93106 9.51736H8.13795L11.3793 6.92426C11.4605 6.85928 11.5584 6.81856 11.6616 6.80678C11.7649 6.795 11.8695 6.81264 11.9632 6.85767C12.0569 6.90271 12.1359 6.9733 12.1913 7.06132C12.2466 7.14933 12.2759 7.25119 12.2759 7.35515V16.6456C12.2759 16.7496 12.2466 16.8515 12.1913 16.9395C12.1359 17.0275 12.0569 17.0981 11.9632 17.1431C11.8695 17.1882 11.7649 17.2058 11.6616 17.194C11.5584 17.1822 11.4605 17.1415 11.3793 17.0765L8.13795 14.4829H5.93106C5.78473 14.4829 5.6444 14.4248 5.54093 14.3213C5.43746 14.2178 5.37933 14.0775 5.37933 13.9312V10.0691C5.37933 9.92276 5.43746 9.78243 5.54093 9.67896C5.6444 9.57549 5.78473 9.51736 5.93106 9.51736Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2016 9.07426C15.9774 9.84998 16.4138 10.9032 16.4138 12C16.4138 13.0969 15.9774 14.1501 15.2016 14.9258M16.7625 7.51343C17.9519 8.70361 18.6201 10.3174 18.6201 12C18.6201 13.6827 17.9519 15.2965 16.7625 16.4867M13.6414 10.6345C14.0033 10.9968 14.2066 11.488 14.2066 12C14.2066 12.5121 14.0033 13.0033 13.6414 13.3656",
    stroke: "white",
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_908_50",
    x: -4,
    y: -4,
    width: 32,
    height: 32,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_908_50"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_908_50",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnmute);
export default __webpack_public_path__ + "static/media/unmute.bc8d0a758efbad426a50f3deb5025347.svg";
export { ForwardRef as ReactComponent };